var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-col',[_c('v-sheet',{attrs:{"height":"400"}},[_c('v-calendar',{attrs:{"color":"primary","type":"day"},scopedSlots:_vm._u([{key:"day-header",fn:function(ref){
var present = ref.present;
return [(present)?[_vm._v(" Today ")]:_vm._e()]}},{key:"interval",fn:function(ref){
var hour = ref.hour;
return [_c('div',{staticClass:"text-center"},[_vm._v(" "+_vm._s(hour)+" o'clock ")])]}}])})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }